angular.module('aprima-core-ui', [
    'ui.router',
    'restangular',
    'ngTouch',
    'ngAnimate',
    'truncate',
    'ui.bootstrap',
    'angularLocalStorage',
    'gettext',
    'lodash',
    'toaster',
    'rt.debounce',
    'hmTouchEvents',
    'ui.tinymce',
    'ngSanitize',

    //aprima
    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
]);